import React from 'react';
import { pressItem } from '../../data/mock';
import { ExternalLink, Award } from 'lucide-react';

const PressSection = () => {
  return (
    <section className="py-16 bg-cream-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-r from-soft-taupe/20 to-warm-sage/10 rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            {/* Icon */}
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-full bg-white shadow-sm flex items-center justify-center">
                <Award className="w-10 h-10 text-warm-sage" />
              </div>
            </div>

            {/* Content */}
            <div className="text-center md:text-left flex-grow">
              <p className="font-montserrat text-xs uppercase tracking-[0.2em] text-warm-sage mb-2">
                Sajtómegjelenés
              </p>
              <h3 className="font-playfair text-2xl text-charcoal mb-3">
                {pressItem.title}
              </h3>
              <p className="font-montserrat text-sm text-warm-gray mb-4">
                {pressItem.description}
              </p>
              <a
                href={pressItem.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 font-montserrat text-sm text-warm-sage hover:text-warm-sage/80 transition-colors group"
              >
                {pressItem.linkText}
                <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PressSection;
